// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps, RouteProps } from 'react-router';

import Alarms from './loaders/Alarms';
import Notifications from './loaders/Notifications';

export const redirects: RedirectProps[] = [
  {
    from: '/alarms',
    to: '/alarms/alarms',
  },
];

export const routes: RouteProps[] = [
  {
    component: Alarms,
    path: '/alarms/alarms',
  },
  {
    component: Notifications,
    path: '/alarms/notifications',
  },
];
